export default __webpack_public_path__ + "static/media/Logo.8c26b11c.png";